import axios from 'axios';

export function initAxiosRequestInterceptor({ router, $q }) {
  axios.interceptors.response.use(
    // Request success
    (response) => {
      if (response.data.redirect) {
        if (response.data.redirect === router.currentRoute.value.path) {
          window.location.reload();
        } else {
          router.push(response.data.redirect);
        }
      }

      return response;
    },
    // Request error
    (error) => {
      if (error.response?.status === 500) {
        const retries = error.response?.config?.['axios-retry']?.retries;
        const retryCount = error.response?.config?.['axios-retry']?.retryCount;

        // Toast error only if it's the last retry
        if (!retries || (retries && retryCount === retries)) {
          $q.notify({
            position: 'top-right',
            message:
              "Une erreur est survenue. Si le problème persiste, veuillez contacter l'assistance.",
            color: 'negative',
            icon: 'error',
          });
        }
      } else if (error.response?.status === 401) {
        const currentPath = router.currentRoute.value.fullPath;
        router.push({
          name: 'Login',
          query: { redirectTo: encodeURIComponent(currentPath) },
        });
      } else if ([403, 404].includes(error.response?.status) && error.response?.data?.redirect) {
        router.push(error.response.data.redirect);
      }

      return Promise.reject(error);
    },
  );
}
